export default {
    fullScreenControlWrapper: 'm-10 lg:hidden',
    topWrapper: 'storeWrapper flex flex-wrap pt-70 lg:relative',
    /* mapWrapper: 'mapWrapper w-full lg:w-2/3 absolute lg:fixed', */
    mapWrapper: 'mapWrapper w-full lg:w-2/3 hidden lg:block absolute lg:fixed',
    mapWrapperMob: 'mapWrapper mapWrapperMob w-full lg:w-2/3 relative lg:hidden',
    mapContainer: 'map-container',
    /* searchBoxWrapper: 'searchbox-wrapper lg:fixed', */
    searchBoxWrapper: 'searchbox-wrapper lg:absolute lg:justify-center',
    /* searchBoxWrapperTop: 'searchbox-wrapper lg:fixed lg:justify-center', */
    searchInputWrapper: 'relative china-search',
    searchBoxTitle: 'header3 mb-15 text-darkGrey',
    disclaimer: 'text-red my-10',
    searchBox: 'search-box bestsellerfont4 w-full h-auto shadow-none text-justkGrey rounded-none placeholder-gray-600',
    searchBoxHidden: 'search-box-hidden w-full invisible block',
    searchBtnWrapperX: 'search-btn-wrapper-x relative',
    searchBtnWrapperXC: 'search-btn-wrapper-x',
    searchBtnWrapper: 'search-btn-wrapper px-30 lg:px-0 hidden lg:block',
    /* searchBtnWrapper: 'search-btn-wrapper hidden lg:block',*/
    searchBtnWrapperMob: 'search-btn-wrapper px-30 block lg:hidden',
    searchBtn: 'search-btn absolute',
    /* searchButton: 'new-storehbtn bg-red text-white p-10 my-20 lg:mt-30 ', */
    searchButton: 'new-storehbtn bg-red text-white p-10 my-20 lg:mt-30',
    rightPanel:'sl right-panel w-full lg:relative',
    searchCrossBtn: 'search-cross-btn absolute',
    storeListWrapper: 'storeList pb-20',
    blockHide:'pb-0 lg:pb-0',
    storeDetailsWrapper:'store-details pb-20 lg:pb-0',
    mapMarkerIcon:'map-marker-icon',
    default: {
        //common for all locators
        mapContainer: 'map-container',
        searchBoxWrapper: 'searchbox-wrapper lg:fixed',
        searchInputWrapper: 'relative',
        disclaimer: 'text-red my-10',
        searchBoxHidden: 'search-box-hidden w-full invisible block',
        storeDetailsWrapper: 'store-details pb-20 lg:pb-0',
        mapMarkerIcon: 'map-marker-icon',
        //storeDetails
        storeDetails: {
            storeTilesWrapper: 'storeList',
            storeTiles: 'store-tiles',
            storeName: 's-details header4 mb-8 text-darkGrey storeName font-bold',
            storeDesc: 'body-small mb-20 text-darkGrey storeDesc',
            bottomSectionWrap: 'flex flex-wrap eyebrow-small text-darkGrey',
            phStyle: 'ph flex-auto',
            distanceStyle: 'ph flex-none text-justGrey text-right mr-5 small-caps',
            directionStyle: 'ph flex-none text-red text-right small-caps uppercase',
            crossWrapper: 'cross-wrapper',
            cross: 'cross',
            instore: 'border-black m-45 pt-15 InstoreWrapper',
            instoreTitle: 'bestsellerfont3 text-darkGrey',
            instoreaddress: "body-small mt-10 text-darkGrey"
        },
    },

    //specific to gen3 store
    store: {
        searchBox: 'search-box bestsellerfont4 w-full h-auto shadow-none text-justkGrey rounded-none placeholder-gray-600',
        searchBtnWrapper: 'search-btn-wrapper relative px-30 lg:px-0 hidden lg:block',
        searchBtn: 'search-btn absolute',
        searchBtnWrapperMob: 'search-btn-wrapper px-30 block lg:hidden',
        searchButton: 'new-storehbtn bg-red text-white p-10 my-20 lg:mt-30',
        searchCrossBtn: 'search-cross-btn absolute',
        searchBtnWrapperX: 'search-btn-wrapper-x relative',
        storeListheading: {
            text: 'listcount body-small text-almostBlack',
            mainWrapper: '',
        },
        storeList: {
            storeTiles: 'store-tiles',
            storeName: 'header4 mb-8 text-darkGrey storeName',
            storeDesc: 'body-small mb-20 text-darkGrey storeDesc',
            bottomSectionWrap: 'flex flex-wrap eyebrow-small text-darkGrey',
            phStyle: 'ph flex-auto',
            distanceStyle: 'ph flex-none text-justGrey text-right mr-5 small-caps',
            directionStyle: 'ph flex-none text-red text-right small-caps uppercase'
        },
        //markerURL: 'https://res.cloudinary.com/mtree/image/upload/w_auto,q_auto,f_svg,fl_sanitize/SKII-JP-Nocompetition/2X5yhvE3DdePjl3B4hjGaO/276c779d1aa630f22d6d1f5d8213887b/pin-icon-red.svg',
        findStore: {
            topWrapper: 'storeWrapper flex flex-wrap pt-70 lg:relative',
            mapWrapper: 'mapWrapper w-full lg:w-2/3 static lg:fixed',
            searchBoxTitle: 'header3 mb-15 text-darkGrey',
            rightPanel: 'right-panel w-full lg:relative',
            storeListWrapper: 'storeList  pb-20 lg:pb-0',
        },

    },

    //specific to now  store
    nowStore: {
        storeList: {
            storeTiles: 'store-tiles border-b border-lightGrey ',
            storeName: 'storeName  nwappt-timemonth lg:text-justblack',
            storeButton: 'nowPrimary text-link w-full bg-red rounded py-10 mb-16 lg:mb-30 mt-20 text-white min-h-44',
            storeDesc: 'body-small text-16 mt-5 text-almostBlack lg:text-justblack text-left storeDesc keep-all',
            bottomSectionWrap: 'flex flex-wrap eyebrow-small text-darkGrey mt-5',
            phStyle: 'ph flex-auto body-small text-16 text-left text-almostBlack lg:text-justblack',
            distanceStyle: 'ph flex-none text-justGrey text-right ml-5 small-caps text-14 md:text-16',
            directionStyle: 'ph flex-none text-right underline body-footer text-justGrey lg:text-justblack'
        },
        //markerURL: 'https://res.cloudinary.com/mtree/image/upload/w_auto,q_auto,f_svg,fl_sanitize/SKII-JP-Nocompetition/2X5yhvE3DdePjl3B4hjGaO/276c779d1aa630f22d6d1f5d8213887b/pin-icon-red.svg',
        storeListheading: {
            text: 'listcountapt small-text bg-lightgrey1 text-justGrey text-center lg:text-left',
            mainWrapper: 'block text-center lg:text-left',
            disclamierText: 'text-red small-text pt-15 lg:pt-20 pb-6 text-center lg:text-left px-25 lg:px-0'
        },
        mapMarkerIcon: 'map-marker-icon',
        disclaimer: 'text-red my-10',
        searchBtnWrapper: 'search-btn-wrapper',
        searchBtn: 'nwappt-search-btn absolute',
        labelStyles: 'hidden',
        searchCrossBtn: 'search-cross-btn-appt absolute',
        searchBox: 'nowapptlocator-search-box border-b focus:outline-none outline-none border-darkGrey pb-10 pl-5 pr-35 body-medium w-full h-auto shadow-none text-justkGrey rounded-none',
        appointmentStore: {
            topWrapper: 'appointment storeWrapper flex flex-wrap mt-60 lg:mt-80',
            mapWrapper: 'mapWrapper-locator w-full lg:w-7/12  lg:fixed mapWrapper-locatormobile',
            searchBoxTitle: 'header4 mt-40 lg:mt-5 mb-25 lg:mb-50 text-darkGrey lg:text-black',
            rightPanel: 'nwaptright-panel bg-white w-full lg:relative nwaptright-panelmobile',
            storeListWrapper: 'storeList mx-25 lg:mx-0 pb-20 lg:pb-0',
        },
        redeemStore: {
            topWrapper: 'storeWrapper flex flex-wrap h-full w-full',
            mapWrapper: 'min-h-445 lg:min-h-auto w-full lg:w-7/12 h-full lg:absolute lg:top-0 lg:left-0 mapWrapper-locatormobile',
            searchBoxTitle: 'header4 mt-20 lg:mt-5 mb-30 lg:mb-50 text-darkGrey lg:text-black',
            rightPanel: 'rdmright-panel nwaptright-panel bg-white w-full lg:absolute lg:top-0 nwaptright-panelmobile lg:overflow-y-auto',
            storeListWrapper: 'storeList lg:px-0 pb-20 lg:pb-0',
            suggestionStyles: 'suggestion-list',
        },
    }

}
